(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

module.exports = function () {
    var FireClick = {};

    FireClick.init = function () {
        // fire and log click
        // Ajax.send params: url, params, onSuccess, onError
        window.P2A.Helpers.Ajax.send('/ajax/clicks/log', { method: 'POST', data: window.P2A.ServerParams }, function (success) {
            mixpanel.track("ShortURL JS Click", {
                "shortUrlId": window.P2A.ServerParams.shortUrlId,
                "userAgent": window.P2A.ServerParams.userAgent,
                "ipAddress": window.P2A.ServerParams.ipAddress,
                "referer": window.P2A.ServerParams.referer
            });
        }, function (error) {
            mixpanel.track("ShortURL JS Click Error", {
                "error": error,
                "shortUrlId": window.P2A.ServerParams.shortUrlId
            });
        });
    };

    return FireClick;
};

},{}],2:[function(require,module,exports){
'use strict';

var ClickTracker = {
    fireClick: {}
};

if (!window.P2A) {
    window.P2A = {};
}
if (!window.P2A.ClickTracker) {
    window.P2A.ClickTracker = ClickTracker;
}

$(document).ready(function () {
    window.P2A.fireClick = require('./_fireclick')();
    window.P2A.fireClick.init();
});

},{"./_fireclick":1}]},{},[2]);
